<template>
  <div class="list-table-header">
    {{ scope.column.label }}
    <!-- 小程序二维码展示，hover 显示小程序码 -->
    <mk-popover
      placement="right"
      trigger="hover"
      width="240"
    >
      <p>
        任务中所有考试的累积分数
      </p>
      <i
        slot="reference"
        class="el-icon-warning"
      >
      </i>
    </mk-popover>
  </div>
</template>
<script>
export default {
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    },
    config: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.list-table-header {
  .el-icon-warning {
    color: #1890ff;
    font-size: 12px;
  }
}
</style>
